import Courses from './Courses'

function CoursesIndex() {
  return (
    <>
      <Courses/>
    </>
  )
}

export default CoursesIndex
